import React, {useEffect} from 'react';
import {UserDetailsFormContextProvider} from '../../components/UserDetailsFormContext';
import {ChangePasswordFormContextProvider} from "../../components/ChangePasswordFormContext";
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {useIntl} from "react-intl";
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import SectionTitle from "../../components/SectionTitle";
import FieldEmail from '../../components/FieldEmail';
import FieldPhone from '../../components/FieldPhone';
import FieldCity from '../../components/FieldCity';
import FieldFirstName from '../../components/FieldFirstName';
import FieldLastName from '../../components/FieldLastName';
import FieldAddress from '../../components/FieldAddress';
import FieldOldPassword from "../../components/FieldOldPassword";
import FieldNewPassword from "../../components/FieldNewPassword";
import FieldRepeatNewPassword from "../../components/FieldRepeatNewPassword";
import ButtonSubmit from '../../components/ButtonSubmit';
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import styles from './Settings.module.scss';

const Settings = () => {
  const {setPageTitle} = useGlobalContext();
  const intl = useIntl();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'settings-page-header'}
        defaultMessage={'Order Invoice'}
      />
    ));
  }, []);

  return (
    <>
      <UserDetailsFormContextProvider>
        <SectionPanel>
          <SectionTitle
            title={
              intl.formatMessage({
                id: 'settings-title-user-settings',
                defaultMessage: 'User settings'
              })
            }
          />
          <div className={styles.fieldsContainer}>
            <FieldEmail/>
            <FieldPhone/>
            <FieldCity/>
            <FieldFirstName/>
            <FieldLastName/>
            <FieldAddress/>
          </div>
        </SectionPanel>
      </UserDetailsFormContextProvider>
      <ChangePasswordFormContextProvider>
        <SectionPanel>
          <SectionTitle
            title={
              intl.formatMessage({
                id: 'settings-title-change-password',
                defaultMessage: 'Change password'
              })
            }
          />
          <div className={styles.fieldsContainer}>
            <FieldOldPassword/>
            <FieldNewPassword/>
            <FieldRepeatNewPassword/>
          </div>
          <div className={styles.submitButtonContainer}>
            <ButtonSubmit/>
          </div>
        </SectionPanel>
      </ChangePasswordFormContextProvider>
      <FooterDivider/>
      <FooterLogo/>
    </>
  );
};

export default Settings;
